import { ExtensionsType } from 'src/Libs/api/types'
import { CloudKeyModel } from 'src/Libs/installation-rights-management/models'

export const isDirectMarketingKeyInUse = (cloudKeyModel: CloudKeyModel): boolean => {
  return cloudKeyModel.inUse === true && cloudKeyModel.scope === ExtensionsType.luoxEnergy
}
